import { contains as s, parentAutofocusables as p } from "./DOMutils.js";
import { asArray as l } from "./array.js";
var c = function(o, r) {
  return r === void 0 && (r = []), r.push(o), o.parentNode && c(o.parentNode.host || o.parentNode, r), r;
}, u = function(o, r) {
  for (var e = c(o), n = c(r), a = 0; a < e.length; a += 1) {
    var f = e[a];
    if (n.indexOf(f) >= 0)
      return f;
  }
  return !1;
}, g = function(o, r, e) {
  var n = l(o), a = l(r), f = n[0], t = !1;
  return a.filter(Boolean).forEach(function(v) {
    t = u(t || v, v) || t, e.filter(Boolean).forEach(function(m) {
      var i = u(f, m);
      i && (!t || s(i, t) ? t = i : t = u(i, t));
    });
  }), t;
}, A = function(o, r) {
  return o.reduce(function(e, n) {
    return e.concat(p(n, r));
  }, []);
};
export {
  A as allParentAutofocusables,
  u as getCommonParent,
  g as getTopCommonParent
};
